import { trackEvent } from './metaPixel'

// ⚠️ Replace this with your real Hotmart checkout URL when ready.
export const HOTMART_CHECKOUT_URL = 'https://pay.hotmart.com/J106065263T'

/**
 * Fires the Meta Pixel InitiateCheckout event and redirects to Hotmart.
 * Use this as the onClick handler for every "Buy" CTA button.
 */
export function goToCheckout(): void {
  trackEvent('InitiateCheckout', {
    content_name: 'Alpha Protocol',
    content_category: 'Digital Product',
    value: 6.36,
    currency: 'USD',
  })
  window.location.href = HOTMART_CHECKOUT_URL
}
